import accessors from '../accessors';
import constants from '../constants';

const { renderStatuses } = constants;

const isRuntimeRender = () => {
  const renderStatus = accessors.getRenderStatus();

  return renderStatus === renderStatuses.RUNTIME;
};

export default isRuntimeRender;
